export default __webpack_public_path__ + "static/simple-area-f1bb77ed45f676e62b9f69e40759261b.png";